import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiKoreksiFiskalNilaiSisaService = new CrudCustom('/transaksi-koreksi-fiskals/calculate-nilai-sisa');
export default TransaksiKoreksiFiskalNilaiSisaService;
